// extracted by css-extract-rspack-plugin
export default {"interruptedBanner":"InterruptedBanner-module__interruptedBanner__Gd4hD","hasContent":"InterruptedBanner-module__hasContent__ZgYcC"};